import { useEffect } from 'react';
import { EditorComponent, Remirror, useRemirrorContext } from '@remirror/react';
import type { RootNode } from '@trinity/chat/src/types/rich-text';
import { cx } from '@trinity/chat-components/utils';
import { useBasicRichTextEditor } from './hooks/useBasicRichTextEditor';
import styles from './style.module.css';

type Props = {
  value: RootNode;
  className?: string;
  editorClassName?: string;
};

// Component to update content when value prop changes
const ContentUpdater = ({ value }: { value: RootNode }) => {
  const { setContent } = useRemirrorContext();

  useEffect(() => {
    setContent(value);
  }, [value, setContent]);

  return null;
};

export const BasicRichText = ({ value, className, editorClassName }: Props) => {
  const { manager, state, onChange } = useBasicRichTextEditor({
    initialState: value,
  });

  return (
    <div className={cx(styles.root, className)}>
      <Remirror
        classNames={[styles.editor, editorClassName]}
        editable={false}
        manager={manager}
        initialContent={state}
        onChange={onChange}>
        <ContentUpdater value={value} />
        <EditorComponent />
      </Remirror>
    </div>
  );
};